import AuthenticationService from './../../services/AuthenticationService'

const provinces = {
  namespaced: true,
  state: {
    datas: [],
    loading: false
  },
  getters: {
    getDatas (state) {
      return state.datas
    }
  },
  mutations: {
    SET_DATAS (state, data) {
      state.datas = data
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async all ({ commit }) {
      commit('SET_LOADING', true)
      return await AuthenticationService.get('global/province').then(({ data }) => {
        commit('SET_DATAS', data.data)
        commit('SET_LOADING', false)
      })
    }
  }
}

export default provinces
